export const KEYS = {
  BUTTON_ID: 'apple-pay-submit-button',
};

export const LABELS = {
  PAY: 'Pay',
};

export default KEYS;
